var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoomCardImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99161 20.0927H16.2584V16.8316H12.7541C10.8366 16.8316 9.25615 18.2502 8.99187 20.0927H8.99161ZM6.33671 19.2103C7.80291 19.2103 8.99161 18.0216 8.99161 16.5554C8.99161 15.09 7.80343 13.9021 6.33671 13.9021C4.87231 13.9021 3.68336 15.09 3.68336 16.5554C3.68336 18.0216 4.87231 19.2103 6.33671 19.2103ZM2.12114 12.0401H0.304764V28.2643H2.12114V24.5437H16.2584V21.1826H2.12114V12.0401ZM31.9001 20.6375C31.9001 18.5355 30.1952 16.8314 28.0937 16.8314H17.3479V24.5432H30.0833V28.2639H31.8997L31.8987 20.637L31.9001 20.6375ZM19.8399 6.14794H17.348V3.65625H14.8573V6.14794H12.3653V8.63787H14.8573V11.1311H17.348V8.63787H19.8399V6.14794Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomCardImg);
export default __webpack_public_path__ + "static/media/RoomCardImg.948eb651206b8d2d82ed03e548a18033.svg";
export { ForwardRef as ReactComponent };